import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Form, Select } from 'components/common/form';

import type { Group } from 'shared-types';

interface Props {
  getGroupId: (groupId: number) => void;
}

const AnalyticsGroupFilter = ({ getGroupId }: Props) => {
  const { messages } = useReduxState();

  const { data } = useApiData({ url: '/admin/groups-available' });

  if (!data?.groups) return null;

  const options = [
    { label: messages.commonAllGroups, value: 0 },
    ...(data?.groups
      ? data.groups.map((group: Group) => ({
          label: group.title,
          value: group.id
        }))
      : [])
  ];

  const initialValues = { groupId: 0 };

  return (
    <div className="filter">
      <Form initialValues={initialValues}>
        <Select
          field="groupId"
          id="groupId"
          isSearchable={true}
          onChange={(groupId: number) => getGroupId(groupId)}
          options={options}
        />
      </Form>
    </div>
  );
};

export default AnalyticsGroupFilter;
